import { BrowserCacheLocation, type Configuration, LogLevel, type RedirectRequest } from '@azure/msal-browser';

const authority = process.env.NEXT_PUBLIC_ENTRA_AUTHORITY || '';
const clientId = process.env.NEXT_PUBLIC_ENTRA_CLIENT_ID || '';
const domain = process.env.NEXT_PUBLIC_ENTRA_DOMAIN || '';
const requestedScopes = process.env.NEXT_PUBLIC_ENTRA_API_SCOPES || '';
const redirectUri = '/msal-redirect';

const parseScopes = (raw: string): string[] =>
    raw
        .split(/[,\s]+/)
        .map(scope => scope.trim())
        .filter(Boolean);

const apiScopes = parseScopes(requestedScopes);

export const msalConfig: Configuration = {
    auth: {
        authority,
        clientId,
        knownAuthorities: domain ? [domain] : [],
        redirectUri,
    },
    cache: {
        cacheLocation: BrowserCacheLocation.LocalStorage,
    },
    system: {
        loggerOptions: {
            loggerCallback: (_: LogLevel, message: string, containsPii: boolean) => {
                if (containsPii) {
                    return;
                }

                // The instance is constructed at module scope, so the SSR pass of client components also runs
                // this callback; msal-browser only logs "window is not defined" there (it initialises lazily in
                // the browser), which is noise in the server log.
                if (typeof window === 'undefined') {
                    return;
                }

                // eslint-disable-next-line no-console
                console.log(message);
            },
            logLevel: LogLevel.Warning,
        },
        // Timeout for the v5 redirect bridge iframe.
        iframeBridgeTimeout: 10000,
    },
};

export const loginRequest: RedirectRequest = {
    prompt: 'select_account',
    scopes: Array.from(new Set(['openid', 'profile', ...apiScopes])),
};

export const bootstrapTokenScopes = apiScopes;
